<template>
  <el-container>
    <el-header>
      <h2>Utilisateurs</h2>
    </el-header>
    <el-main>
      <el-form class="actions search-bar" :inline="true" >
        <el-form-item label="Recherche" >
          <el-input v-model="query" @input="load" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-circle-plus" @click="handleEdit()">
            Ajouter
          </el-button>
        </el-form-item>
      </el-form>

      <el-table :data="users" @sort-change="handleSort" >
        <el-table-column sortable="custom" prop="email" label="Email" />
        <el-table-column sortable="custom" prop="lastname" label="Nom" />
        <el-table-column sortable="custom" prop="firstname" label="Prénom" />
        <el-table-column sortable="custom" prop="role" label="Rôle" />
        <el-table-column label="Actions" >
          <el-button-group slot-scope="{row}">
            <el-button type="primary" icon="el-icon-edit" @click="handleEdit(row)" size="small"/>
            <el-button type="danger" icon="el-icon-fa-trash" @click="handleRemove(row)" size="small"/>
          </el-button-group>
        </el-table-column>
      </el-table>
      <el-pagination
         layout="prev, pager, next"
         :total="total"
         :background="true"
         :page-size="limit"
         @current-change="handlePageChange" />
      <el-dialog :title="modalTitle" :visible.sync="modalShow" >
        <el-form v-if="current" :model="current" >
          <el-form-item v-if="!current.id" label="Email" >
            <el-input type="email" v-model="current.email" />
          </el-form-item>
          <el-form-item label="Nom" >
            <el-input v-model="current.lastname" />
          </el-form-item>
          <el-form-item label="Prénom" >
            <el-input v-model="current.firstname" />
          </el-form-item>
          <el-form-item label="Rôle" >
            <el-select v-model="current.role" :clearable="true" >
              <el-option v-for="role in roles" :key="role" :label="role" :value="role" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-circle-check" @click="save" >
              Valider
            </el-button>
            <el-button type="warning" icon="el-icon-circle-close" @click="modalShow = false" >
              Annuler
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import {api} from 'macarons'
import {User} from '../entity'
import {entityCollectionWrap} from '@/utils'

export default {
  data () {
    return {
      debounce: null,
      query: null,
      users: [],
      total: 0,
      limit: 10,
      offset: 0,
      modalShow: false,
      current: null,
      sort: [],
      roles: [
        'ROLE_ADMIN',
        'ROLE_CHLOE',
        'ROLE_CLIENT',
        'ROLE_EVALUATOR'
      ]
    }
  },
  computed: {
    modalTitle () {
      if (this.current === null || !this.current.id) {
        return 'Ajouter un utilisateur'
      }
      return 'Modifier l\'utilisateur ' + this.current.email
    }
  },
  created () {
    this.load()
  },
  methods: {
    handleSort (sort) {
      const index = this.sort.findIndex(s => s.prop === sort.prop)
      if (index !== -1) {
        this.sort.splice(index, 1)
      }
      this.sort.unshift({
        prop: sort.prop,
        order: sort.order
      })
      this.load()
    },
    handleEdit (user) {
      this.current = typeof user === 'undefined' ? new User(user) : user.clone()
      this.modalShow = true
    },
    handleRemove (user) {
      api.delete('user/' + user.id).then(() => {
        this.modalShow = false
        this.load()
      })
    },
    save () {
      api[this.current.id ? 'patch' : 'put'](
        'user' + (this.current.id ? '/' + this.current.id : ''),
        this.current.getData()
      ).then(({data}) => {
        (this.current.hasChangedRole() ? api.get(
          'user/' + data.id + '/promote/' + this.current.role
        ) : Promise.resolve()).then(() => {
          this.modalShow = false
          this.load()
        })
      })
    },
    load () {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        let url = 'users?limit=' + this.limit + '&offset=' + this.offset
        if (this.sort.length) {
          url += '&order=' + this.sort.map(s => s.prop + '@' + s.order).join()
        }
        if (this.query) {
          url += '&q=' + this.query
        }
        api.get(url).then(({data}) => {
          this.users.splice(0, this.users.length, ...entityCollectionWrap(data.users, User))
          this.total = data.count
        })
      }, 200)
    },
    handlePageChange (page) {
      this.offset = (page - 1) * this.limit
      this.load()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/users/components/UserList.vue